module.exports = __webpack_public_path__ + "img/IMG_0078.fd988f19.jpg";